import { Action, createAction, handleActions } from 'redux-actions';
import { IBreadcrumb as IModel } from './breadcrumb.model';

export const ACTION_TYPES = {
    SET: 'breadcrumb/SET',
};

export interface IBreadcrumbState {
    loading: boolean;
    items: IModel[];
}

const initialState = {
    loading: false,
    items: [],
};

export const setBreadcrumb = createAction(ACTION_TYPES.SET);

export default handleActions<IBreadcrumbState, any>(
    {
        [ACTION_TYPES.SET]: (state: IBreadcrumbState, action: Action<IModel[]>): IBreadcrumbState => {
            return { ...state, items: [...action.payload] };
        },
    },
    initialState,
);
